import { connect } from 'react-redux'
import SchoolAvatar from './school-avatar'
import {
  getSchool,
  getUploadAvatarRequest,
  getRemoveAvatarRequest
} from '../../../../../stores/school/school.selectors'
import {
  uploadAvatar,
  removeAvatar
} from '../../../../../stores/school/school.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const school = getSchool(state)
  const uploadAvatarRequest = getUploadAvatarRequest(state)
  const removeAvatarRequest = getRemoveAvatarRequest(state)
  return {
    id: school.id,
    pending: uploadAvatarRequest.pending || removeAvatarRequest.pending,
    url: !school.avatar ? null : school.avatar.url,
    title: school.title,
    avatar: school.logo_url && { url: school.logo_url }
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch
})

const mergeProps = (stateProps, { dispatch }) => ({
  ...stateProps,
  onRemove: id => dispatch(removeAvatar(id)).catch(errorHandler),
  onChange: files => dispatch(uploadAvatar(stateProps.id, files[0]))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SchoolAvatar)
